import React, { useContext } from 'react';
import './PlCapsuleValues.scss';
import AppContext from 'app/AppContext';
import { PlData } from 'widgets/plCapsule/plCapsuleData';
import { usePlDataAtTime } from 'widgets/plCapsule/hooks';

export interface PlCapsuleValuesProps {
    data: PlData;
    time?: number;
    onClick: () => void;
}

export function PlCapsuleValues(props: PlCapsuleValuesProps) {
    const { onClick, time, data } = props;

    const { total, realised, realisedClass, unrealised } = usePlDataAtTime(
        data,
        time
    );

    const { timeFormat } = useContext(AppContext);
    const timeDisplay = time ? timeFormat.toTimeMinutes(time) : '';

    return (
        <div
            className="PlCapsuleValues capsule-values flippable"
            onClick={onClick}
        >
            <div className="time">{timeDisplay}</div>
            <div>
                <div className="label">Total</div>
                <div className="value total">{total}</div>
            </div>
            <div>
                <div className="label">Realised</div>
                <div className={`value realised ${realisedClass}`}>
                    {realised}
                </div>
                <div className="label">Unrealised</div>
                <div className={`value unrealised`}>{unrealised}</div>
            </div>
        </div>
    );
}
